// Libs
import React, { useState } from "react";
import PropTypes from "prop-types";

// Contexts
import FilterContext from "contexts/Filter";

function FilterProvider({ children }) {
  const [claimsV1Data, setClaimsV1Data] = useState({});
  const [claimsV2Data, setClaimsV2Data] = useState({});

  return (
    <FilterContext.Provider
      value={{
        filter: { claimsV1Data, claimsV2Data },
        setClaimsV1Data,
        setClaimsV2Data
      }}
    >
      {children}
    </FilterContext.Provider>
  );
}

FilterProvider.propTypes = {
  children: PropTypes.node
};

export default FilterProvider;
